import type { HttpRequest } from '@angular/common/http';

export function getRequestDomainInfo(req: HttpRequest<unknown>) {
  const url = new URL(req.url);
  const isBeckUrl = url.hostname.endsWith('.beckshybrids.com');
  const isLocalhost = url.hostname === 'localhost';
  const isAppUrl = isBeckUrl || isLocalhost;

  return { isAppUrl, isBeckUrl, isLocalhost };
}
